<div class="d-flex flex-column w-100">
  <app-section-title3 [title]="title" [color]="color"></app-section-title3>
  <div class="w-100 columns">
    <p *ngFor="let item of items" class="item">{{item.description}}</p>
  </div>
</div>
